import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const jsfsPaths = {
	default: '',
	root: 'job-setup-forms',
	list: 'list',
	detail: ':id',
	calendar: 'calendar',
};

export const jsfsFragments = {
	default: [jsfsPaths.default],
	root: [jsfsPaths.default, jsfsPaths.root],
	calendar: [jsfsPaths.default, jsfsPaths.root, jsfsPaths.calendar],
	list: [jsfsPaths.default, jsfsPaths.root, jsfsPaths.list],
	detail: (id: number) => [jsfsPaths.default, jsfsPaths.root, id],
};

export const jsfsDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const jsfsDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: jsfsDefaultAuthRoles },
};
